import React, { useState } from "react";
import ClinicTable from "./ClinicTable";
import ChangeClinicRegion from "./ChangeClinicRegion";
import { Spin, Button } from "antd";
import { SwapOutlined } from "@ant-design/icons";
import useRoleCheck from "utilities/hooks/roleCheck";
import { fetchRegionData } from "utilities/redux/slices/regionSlice";
import { useDispatch } from "react-redux";

const Clinics = ({ region }) => {
  const { hasPermission } = useRoleCheck();
  const dispatch = useDispatch();
  const [regionUpdateVisible, setRegionUpdateVisible] = useState(false);

  const onChange = () => {
    dispatch(fetchRegionData(region?.regionCode));
  };

  if (!region) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spin />
      </div>
    );
  }
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ flexGrow: 1, overflow: "auto" }}>
        <ClinicTable borderd region={region?.regionCode} />
      </div>
      {hasPermission(
        ["Admin.Manage", "Admin.Basic"],
        ["Sales.Exec"],
        region?.regionCode,
        false
      ) && (
        <Button
          style={{ marginTop: "16px" }}
          type="primary"
          onClick={() => setRegionUpdateVisible(true)}
          icon={<SwapOutlined />}
        >
          Change Clinic Region
        </Button>
      )}
      <ChangeClinicRegion
        region={region}
        visible={regionUpdateVisible}
        setVisible={setRegionUpdateVisible}
        onChange={onChange}
      />
    </div>
  );
};

export default Clinics;
